// Tri-state yes/no rendering. A null or undefined value must never read as "No": in
// human-rights data "not recorded" and "no" are different facts, and the validator counts null
// as unanswered.
// A case in an end state is no longer in review; AI-review signals and gates don't apply to it.
export const isEndState = (status?: string | null) => status === 'APPROVED' || status === 'REJECTED' || status === 'ARCHIVED';

export const NOT_RECORDED = 'Not recorded';
export const UNKNOWN_PILL = 'bg-gray-50 text-gray-500 italic border border-dashed border-gray-300 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600';
export const yesNo = (v: boolean | null | undefined, yes = 'Yes', no = 'No') => (v === true ? yes : v === false ? no : NOT_RECORDED);
export const yesNoClass = (v: boolean | null | undefined, yes: string, no: string, unknown = UNKNOWN_PILL) => (v === true ? yes : v === false ? no : unknown);
